<template>
  <div class="wrapper">
    <div class="container">
      <div class="title-page">
        <h1>Bienvenue,</h1>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item" @click.prevent="GoToDashboard"><a>Accueil</a></li>
            <li class="breadcrumb-item active" aria-current="page">Mon compte</li>
          </ol>
        </nav>
      </div>

      <div class="row account-layout">
        <div class="col-lg-3 col-md-12 sidebar-column">
          <MenuSidebarClient :activeTab="activeTab" @change-tab="changeTab" />
        </div>

        <div class="col-lg-9 col-md-12 content-column">
          <div class="content-wrapper">
            <div v-if="activeTab === 'info_client'" class="tab-content">
              <InformationsPersonnelsClientView />
            </div>
            <div v-if="activeTab === 'commandes_client'" class="tab-content">
              <CommandesView />
            </div>
            <div v-if="activeTab === 'adresses_client'" class="tab-content">
              <AdresseLivraisonViewClient />
            </div>
            <div v-if="activeTab === 'carnet_client'" class="tab-content">
              <CarnetClientView :key="carnetKey" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MenuSidebarClient from "@/components/e-supplyvet/MenuSidebarClient.vue";
  import InformationsPersonnelsClientView from "@/views/e-supplyvet/InformationsPersonnelsClientView.vue";
  import CommandesView from "@/views/supplyvet/CommandesView.vue";
  import AdresseLivraisonViewClient from "@/views/e-supplyvet/AdresseLivraisonViewClient.vue";
  import CarnetClientView from "@/views/e-supplyvet/CarnetClientView.vue";
  import { useProductsStore } from "@/stores/productsStore";
  export default {
    components: {
      MenuSidebarClient,
      InformationsPersonnelsClientView,
      CommandesView,
      CarnetClientView,
      AdresseLivraisonViewClient,
    },
    data() {
      return {
        activeTab: "info_client",
        carnetKey: 0,
      };
    },
    methods: {
      changeTab(tab) {
        this.activeTab = tab;
        if (tab === "carnet_client") {
          this.carnetKey += 1;
        }
      },
      handleSubmit() {
        this.form.name = "";
      },
      Logout() {
        const productsStore = useProductsStore();
        localStorage.clear();
        localStorage.removeItem("token");

        productsStore.$reset();
        localStorage.removeItem("products");
        localStorage.clear();
        this.$router.push({ name: "Home" });
      },
      openDropdown() {
        this.isOpen = true;
      },
      closeDropdown() {
        this.isOpen = false;
      },

      GoToDashboard() {
        this.$router.push({ name: "dashboard-home" });
      },
    },
  };
</script>

<style scoped>
/* Styles spécifiques pour la responsivité de la page mon compte */
.account-layout {
  min-height: calc(100vh - 200px);
}

.sidebar-column {
  position: relative;
}

.content-column {
  position: relative;
}

.content-wrapper {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  padding: 20px;
  min-height: 400px;
}

.tab-content {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive pour tablettes */
@media (max-width: 991px) {
  .account-layout {
    flex-direction: column;
  }
  
  .sidebar-column {
    order: 1;
    margin-bottom: 20px;
  }
  
  .content-column {
    order: 2;
  }
  
  .content-wrapper {
    padding: 15px;
  }
}

/* Responsive pour mobile */
@media (max-width: 767px) {
  .wrapper {
    padding: 10px;
  }
  
  .container {
    padding: 0;
  }
  
  .title-page {
    text-align: center;
    margin-bottom: 15px;
  }
  
  .title-page h1 {
    font-size: 20px;
    margin-bottom: 8px;
  }
  
  .breadcrumb {
    justify-content: center;
    font-size: 12px;
  }
  
  .content-wrapper {
    padding: 12px;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  }
  
  .sidebar-column {
    margin-bottom: 15px;
  }
}

/* Responsive pour très petits écrans */
@media (max-width: 575px) {
  .wrapper {
    padding: 5px;
  }
  
  .title-page h1 {
    font-size: 18px;
  }
  
  .breadcrumb {
    font-size: 11px;
  }
  
  .content-wrapper {
    padding: 10px;
  }
}

/* Amélioration de l'accessibilité */
.title-page h1:focus,
.breadcrumb a:focus {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
  border-radius: 4px;
}
</style>
